import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_col = _resolveComponent("v-col")
  const _component_v_row = _resolveComponent("v-row")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.localBlackList.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.localBlackList.email) = $event)),
              label: "Email",
              variant: "outlined",
              rules: [(v) => !!v || 'Email is required'],
              "validate-on": "blur"
            }, null, 8, ["modelValue", "rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.localBlackList.firstName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.localBlackList.firstName) = $event)),
              label: "First name",
              variant: "outlined",
              "validate-on": "blur"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.localBlackList.lastName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.localBlackList.lastName) = $event)),
              label: "Last name",
              variant: "outlined",
              "validate-on": "blur"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}